import { SystemMessageModel } from '../domain/system-model';

export abstract class SystemRepository {
  abstract getNotifications(environment: string): Promise<SystemMessageModel[]>;
}
